import { Link } from "react-router-dom";

export default function Footer() {
    return (
        <footer
            className="mt-24 border-t"
            style={{ borderColor: "var(--st-line)", background: "var(--st-silver-50)" }}
            data-testid="site-footer"
        >
            <div className="max-w-6xl mx-auto px-6 py-12">
                {/* Instructor card intentionally removed from footer (2026-02).
                    Admin CMS + short-bio field + API remain intact — flip back on
                    by restoring the useEffect+state and the <div data-testid="footer-instructor-card"> block. */}

                <div className="grid gap-10 md:grid-cols-3">
                    <div>
                        <div className="font-serif text-xl">
                            <span style={{ color: "var(--st-navy)" }}>Swing</span>
                            <span style={{ color: "var(--st-royal)" }}>Trust</span>
                        </div>
                        <p
                            className="tracking-caps mt-1 text-[10px] font-semibold"
                            style={{ color: "var(--st-silver-500)" }}
                        >
                            Swing Trading Education Academy
                        </p>
                        <p
                            className="mt-6 text-sm leading-relaxed max-w-xs"
                            style={{ color: "var(--st-ink-muted)" }}
                        >
                            An institutional-grade curriculum built around structure, patience,
                            and evidence — not hype.
                        </p>
                    </div>

                    <div>
                        <div
                            className="tracking-caps text-[11px] font-semibold mb-4"
                            style={{ color: "var(--st-ink-muted)" }}
                        >
                            Platform
                        </div>
                        <ul className="space-y-2 text-sm">
                            <li><Link to="/" className="link-royal" data-testid="footer-link-home">Home</Link></li>
                            <li><Link to="/login" className="link-royal" data-testid="footer-link-login">Sign in</Link></li>
                            <li><Link to="/signup" className="link-royal" data-testid="footer-link-signup">Enroll as student</Link></li>
                            <li><Link to="/affiliates" className="link-royal" data-testid="footer-link-affiliate-program">Affiliate program</Link></li>
                            <li><Link to="/affiliate/signup" className="link-royal" data-testid="footer-link-affiliate">Become an affiliate</Link></li>
                            <li><Link to="/blog" className="link-royal" data-testid="footer-link-blog">Journal</Link></li>
                        </ul>
                    </div>

                    <div>
                        <div
                            className="tracking-caps text-[11px] font-semibold mb-4"
                            style={{ color: "var(--st-ink-muted)" }}
                        >
                            Legal
                        </div>
                        <ul className="space-y-2 text-sm">
                            <li><Link to="/terms" className="link-royal" data-testid="footer-link-terms">Terms of Service</Link></li>
                            <li><Link to="/privacy" className="link-royal" data-testid="footer-link-privacy">Privacy Policy</Link></li>
                            <li><Link to="/risk-disclosure" className="link-royal" data-testid="footer-link-risk">Risk Disclosure</Link></li>
                        </ul>
                    </div>
                </div>

                <div
                    className="mt-12 pt-8 text-xs leading-relaxed"
                    style={{ borderTop: "1px solid var(--st-line)", color: "var(--st-ink-muted)" }}
                    data-testid="footer-disclaimer"
                >
                    <p>
                        <strong style={{ color: "var(--st-navy)" }}>Important disclaimer.</strong>{" "}
                        SwingTrust provides educational content only. Nothing on this platform
                        constitutes financial advice. Trading involves substantial risk of loss.
                    </p>
                    <p className="mt-3">
                        © {new Date().getFullYear()} SwingTrust. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
}
